import { render, staticRenderFns } from "./ForgotPasswordReset.vue?vue&type=template&id=2c208a98&scoped=true&"
import script from "./ForgotPasswordReset.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordReset.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordReset.vue?vue&type=style&index=0&id=2c208a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c208a98",
  null
  
)

export default component.exports